<div class="modal-header">
  <h4 class="modal-title h5" translate>New Gateway</h4>
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form (ngSubmit)="onSave()" [formGroup]="gatewayForm">
  <div class="modal-body">

    <!-- GATEWAY TYPE -->
    <div class="form-group">
      <label for="gatewayType" translate>Gateway type</label>
      <scitis-required-field-indicator></scitis-required-field-indicator>
      <ng-select (change)="onGatewayTypeChange($event)" [items]="possibleGatewayTypes"
                 [ngClass]="{ 'is-invalid': f.gatewayType.errors }"
                 bindLabel="typeName"
                 bindValue="typeName"
                 formControlName="gatewayType"
                 id="gatewayType">
        <ng-template let-item="item" ng-label-tmp>
          <span [innerHTML]="item|translate"></span>
        </ng-template>

        <ng-template let-item="item" ng-option-tmp>
          <span class="d-block" [innerText]="item|translate"></span>
        </ng-template>

      </ng-select>
      <input [hidden]="true" [ngClass]="{ 'is-invalid': f.tenant.errors }" class="form-control"
             id="typeName" name="typeName"
             type="text">

      @if (f.gatewayType.errors) {
        <div class="invalid-feedback">
          @if (f.gatewayType.errors.required) {
            <span translate>Gateway type required</span>
          }
        </div>
      }
    </div>

    <!-- CLOUDPLUG LIGHT & GENERIC SPECIFIC SETTINGS-->
    @if (isLightCloudplug() || isGenericCloudplug()) {
      <div class="form-row">
        @if (isLightCloudplug()) {
          <div class="col-12">
            <!--SOURCE CLOUDPLUG LIGHT-->
            <div class="form-group">
              <!--COPY CHECKBOX-->
              <div class="custom-control custom-switch">
                <input (change)="onCopySettingsChange()" [checked]="copySettings"
                       [value]="copySettings"
                       class="custom-control-input"
                       id="copySettings" type="checkbox">
                <label class="custom-control-label" for="copySettings" translate>Copy settings from another CloudPlug
                  light</label>
              </div>
              <ng-select (change)="onSourceCloudplugLightChange($event)" [disabled]="!copySettings"
                         [items]="lightCloudplugs"
                         bindLabel="name"
                         bindValue="name" formControlName="sourceCloudplugLight"
                         id="sourceCloudplugLight">
              </ng-select>
              <input [hidden]="true" [ngClass]="{ 'is-invalid': f.sourceCloudplugLight.errors }"
                     class="form-control" id="cpLightName" name="cpLightName"
                     type="text">
            </div>
          </div>
        }
        <div class="col-12">
          <div class="form-row">
            <!-- CLOUDPLUG LIGHT REGISTRY ID -->
            <div class="col-12 col-lg-6">
              <div class="form-group">
                @if (loadRegistryIds) {
                  <span class="fa-solid fa-spinner fa-spin ml-2"></span>
                }
                <label for="registry" translate>Tenant Id</label>
                <scitis-required-field-indicator></scitis-required-field-indicator>
                <ng-select [items]="iotCoreRegistryIds" [ngClass]="{ 'is-invalid': f.name.errors }"
                           formControlName="registry"
                           id="registry">
                </ng-select>
                <input [hidden]="true" [ngClass]="{ 'is-invalid': f.registry.errors }" class="form-control"
                       id="registryName" name="registryName"
                       type="text">
                @if (f.registry.errors) {
                  <div class="invalid-feedback">
                    @if (f.registry.errors.required) {
                      <span translate>Registry id required</span>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- GATEWAY NAME & ORGANIZATION -->
    <div class="form-row">
      <!-- name -->
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label for="name" translate>Name</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          <input [ngClass]="{ 'is-invalid': f.name.errors }" class="form-control" formControlName="name"
                 id="name" name="name"
                 type="text">

          @if (f.name.errors) {
            <div class="invalid-feedback">
              @if (f.name.errors.required) {
                <span translate>Gateway name required</span>
              }
              @if (f.name.errors.pattern) {
                <span
                    translate>The name can only consist of latin letters, numbers, underscores.</span>
              }
            </div>
          }
        </div>
      </div>
      <!-- organization -->
      <div class="col-12 col-lg-6">
        <div class="form-group">
          @if (isLoadingOrganizations) {
            <span class="fa-solid fa-spinner fa-spin"></span>
          }
          <label for="tenant" translate>Organization</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          <ng-select (change)="onChangeOrganization($event)" [items]="possibleOrganizations"
                     [ngClass]="{ 'is-invalid': f.tenant.errors }"
                     bindLabel="name"
                     bindValue="name"
                     formControlName="tenant"
                     id="tenant">
          </ng-select>
          <input [hidden]="true" [ngClass]="{ 'is-invalid': f.tenant.errors }" class="form-control"
                 id="tenantName" name="tenantName"
                 type="text">

          @if (f.tenant.errors) {
            <div class="invalid-feedback">
              @if (f.tenant.errors.required) {
                <span translate>Organization required</span>
              }
            </div>
          }
        </div>
      </div>
    </div>

    <!-- SERIAL NUMBER & MACHINE -->
    <div class="form-row">
      <!-- SERIAL NUMBER -->
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label for="serial" translate>Serial number</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          @if (checkingForSerialNumberAlreadyUsed) {
            <span class="fa-solid fa-gear fa-spin"></span>
          }
          <input [ngClass]="{ 'is-invalid': f.serial.errors }" class="form-control"
                 (change)="onSerialNumberChange()"
                 formControlName="serial" id="serial" name="serial"
                 type="text">
          @if (f.serial.errors) {
            <div class="invalid-feedback">
              @if (f.serial.errors.required) {
                <span translate>Serial number required</span>
              }
              @if (f.serial.errors.minlength || f.serial.errors.pattern) {
                <span
                    translate>The serial number must be at least 5 characters long and can only contain latin letters, numbers, and underscores!</span>
              }
              @if (f.serial.errors.used) {
                <span translate>The serial number already exists!</span>
              }
            </div>
          }
        </div>
      </div>
      <!-- machine -->
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label for="machine" translate>Machine</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          <ng-select (change)="onChangeMachine($event)" [items]="possibleMachines"
                     [ngClass]="{ 'is-invalid': f.machine.errors }"
                     bindLabel="name"
                     bindValue="name"
                     formControlName="machine"
                     id="machine">
          </ng-select>
          <input [hidden]="true" [ngClass]="{ 'is-invalid': f.machine.errors }" class="form-control"
                 id="machineName" name="machineName"
                 type="text">

          @if (f.machine.errors) {
            <div class="invalid-feedback">
              @if (f.machine.errors.required) {
                <span translate>Machine required</span>
              }
            </div>
          }
        </div>
      </div>
    </div>

  </div>

  <div class="modal-footer">
    <div class="modal-footer-inner">
      <div class="row align-items-center flex-fill">
        <div class="col">
          <scitis-required-field-indicator-explanation></scitis-required-field-indicator-explanation>
        </div>
        <div class="col-auto">
          <button (click)="onCancel()" class="btn btn-outline-primary mr-2" type="button">
            <span translate>Cancel</span>
          </button>
          <button [disabled]="checkingForSerialNumberAlreadyUsed || isDisabledSaveBtn" class="btn btn-primary"
                  type="submit">
            <span translate>Save</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</form>